function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.667 7.634h2.125V5.089h2.416v2.545h2.125L10 11.027 6.667 7.634zm9.458-2.51C18.292 5.275 20 7.09 20 9.33c0 .557-.108 1.109-.317 1.623-.21.515-.517.982-.903 1.376a4.16 4.16 0 01-1.352.92 4.104 4.104 0 01-1.595.322H5a4.956 4.956 0 01-3.536-1.49A5.136 5.136 0 010 8.482c0-2.62 1.95-4.784 4.458-5.055a6.314 6.314 0 012.3-2.503A6.165 6.165 0 0110 0c1.446 0 2.847.51 3.964 1.445a6.375 6.375 0 012.161 3.678zm-.292 6.751c.663 0 1.3-.268 1.768-.745a2.552 2.552 0 00.06-3.519 2.466 2.466 0 00-1.644-.791l-1.275-.094-.25-1.272a4.684 4.684 0 00-1.586-2.696A4.537 4.537 0 0010 1.696c-1.717 0-3.267.967-4.058 2.52l-.417.805-.892.094a3.291 3.291 0 00-2.12 1.102 3.405 3.405 0 00-.846 2.265c0 .9.35 1.763.976 2.4A3.304 3.304 0 005 11.874h10.833z",
  fill: "#fff"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDownload;